import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { IconButton } from "@mui/material";

type PropsType = {
    readonly onButtonClick?: () => void;
    readonly addIcon?: boolean;
    readonly minusIcon?: boolean;
};

function AddRemoveInput({ onButtonClick, addIcon, minusIcon }: PropsType) {
    return (
        <IconButton
            className={"add-icon-button"}
            style={{ padding: 0 }}
            color={"primary"}
            onClick={onButtonClick}
        >
            {addIcon && <AddIcon viewBox={"3 3 18 18"} titleAccess={"Aggiungi"} />}

            {minusIcon && <RemoveIcon viewBox={"3 3 18 18"} titleAccess={"Rimuovi"} />}
        </IconButton>
    );
}

export default AddRemoveInput;
